import React from "react";
import { useLocation } from "react-router-dom";
import PriceOfferChildNoDsicount from "./PriceOfferChildNoDsicount";
import PriceOfferChildTimeRestrictedDiscounted from "./PriceOfferChildTimeRestrictedDiscounted";
import PriceOfferChildGrandUpsellDiscounted from "./PriceOfferChildGrandUpsellDiscounted";
import LastMonthTotalSales from "../LastMonthTotalSales/LastMonthTotalSales";
import { useCalculateLastMonthsSales } from "../../hooks/useCalculateLastMonthsSales";

export default function PriceOffer(props) {
  const location = useLocation();

  // PROPS COMING FROM PurchaseComponent && ProductLandings
  const {
    product,
    price,
    validPrice,
    isPending,
    isDiscountValid,
    remainingTime,
    cartSkuItems,
    // hasItemInPendingOrder,
  } = props;

  // BRING IN LAST MONTH SALES
  const { lastMonthsTotalSale } = useCalculateLastMonthsSales(product);

  return (
    <>
      {product.timeLimitedDiscount.discountAmount === 0 &&
      isPending?.isTherePending !== "YES" ? (
        <PriceOfferChildNoDsicount product={product} price={price} />
      ) : isPending?.isTherePending === "YES" ? (
        <PriceOfferChildGrandUpsellDiscounted
          product={product}
          price={price}
          isPending={isPending}
          //  hasItemInPendingOrder={hasItemInPendingOrder}
        />
      ) : (
        <>
          {isDiscountValid ? (
            <PriceOfferChildTimeRestrictedDiscounted
              product={product}
              price={price}
              validPrice={validPrice}
              remainingTime={remainingTime}
              cartSkuItems={cartSkuItems}
            />
          ) : (
            <PriceOfferChildNoDsicount product={product} price={price} />
          )}
        </>
      )}
      {location.pathname.includes("/land/") && lastMonthsTotalSale > 100 && (
        <LastMonthTotalSales lastMonthsTotalSale={lastMonthsTotalSale} />
      )}
    </>
  );
}
